import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { FooterComponent } from './layout/footer/footer.component';
import { LoginComponent } from './auth/login/login.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { TableModule } from 'primeng/table';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AccessDeniedComponent } from './auth/access-denied/access-denied.component';
import { HandlerModule } from './handler/handler.module';
import { WebServiceInterceptor } from './web-service.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderServiceService } from './loader-service.service';
import { LoaderComponent } from './modules/loader/loader.component';
import { SalesChartComponent } from './dashboard/sales-chart/sales-chart.component';
import { BarChartComponent } from './dashboard/bar-chart/bar-chart.component';
import { PartsLineChartComponent } from './dashboard/parts-line-chart/parts-line-chart.component';
import { PieChartComponent } from './dashboard/pie-chart/pie-chart.component';



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    LoginComponent,
    DashboardComponent,
    AccessDeniedComponent,
    LoaderComponent,
    SalesChartComponent,
    BarChartComponent,
    PartsLineChartComponent,
    PieChartComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HandlerModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 5000,
      positionClass: 'toast-top-right',
    }),
    BrowserAnimationsModule,
    NgxDatatableModule,
    TableModule,
    BrowserAnimationsModule,
  ],
  providers: [LoaderServiceService,{ provide: HTTP_INTERCEPTORS, useClass: WebServiceInterceptor, multi: true },],
  bootstrap: [AppComponent]
})
export class AppModule { }
